import { render, staticRenderFns } from "./addHospitalTimings.vue?vue&type=template&id=70375234"
import script from "./addHospitalTimings.vue?vue&type=script&lang=js"
export * from "./addHospitalTimings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports